import { render } from "./OrganizationUsageSummary.vue?vue&type=template&id=5571c49a&scoped=true"
import script from "./OrganizationUsageSummary.vue?vue&type=script&lang=js"
export * from "./OrganizationUsageSummary.vue?vue&type=script&lang=js"

import "./OrganizationUsageSummary.vue?vue&type=style&index=0&id=5571c49a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5571c49a"]])

export default __exports__